import React from 'react';
import Select from 'react-select';

function getCategory(column, features) {
    const feature = features.find(feature => feature.Feature === column.Header);
    if (feature) {
        return feature.Category
    } else {
        return " "
    }
}

function getCategoryOptions(columns, features) {
    const formattedColumns = {}
    // work through all the columns, find the category for that column feature
    // make key the category and add all column ids to array as values
    columns.forEach(column => {
        if (column.Header !== "Party ID") {
            const category = getCategory(column, features)
            if (formattedColumns[category]) {
                formattedColumns[category].push(column.accessor)
            } else {
                formattedColumns[category] = [column.accessor];
            }
        }
    })
    /* return an array that looks like
        [
            {
                label: "Transaction",
                value: ["Column2", "Column3"...]
            }
        ]
        so that we can filter out all other columns
        TODO: optimize by setting the value to all other columns other than those 
    */
    return (Object.keys(formattedColumns)).map(column => ({label: column, value: formattedColumns[column]}));
}

export default function CategoryFilter({columns, features, setHiddenColumns}) {
    const categoryOptions = getCategoryOptions(columns, features);
    const allColumns = columns.map(column => column.accessor)
    const filterColumns = (option) => {
        if (option) {
            // set hidden columns to all columns except the selected category and Party Id (IdKey)
            setHiddenColumns(() => allColumns.filter(column => !option.value.includes(column) && column !== "IdKey"));
        } else {
            // if they cancel, show all columns by setting no hidden columns
            setHiddenColumns(() => []);
        }
    }
    const theme = theme => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#9575CD',
          primary25: '#faf5ff',
          primary50: '#d6bcfa',
          neutral20: '#e2e8f0',
          neutral30: '#cbd5e0'
        }})
    return (
        <div className="w-64 mb-3">
            <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="categoryFilter">
                Filter Columns by Feature Category
            </label>
            <Select 
                id="categoryFilter" 
                onChange={filterColumns} 
                options={categoryOptions}
                isClearable={true}
                theme={theme}
                className='text-gray-800'
            />
        </div>
    )
}